const documentElement: any = document;

export class FullScreenHandlerService {

  static isFullscreen(): boolean {
    return Boolean(documentElement.fullscreenElement || documentElement.mozFullScreenElement || documentElement.webkitFullscreenElement || documentElement.msFullscreenElement);
  }

  static getFullscreenElement(): HTMLElement {
    return documentElement.fullscreenElement || documentElement.mozFullScreenElement || documentElement.webkitFullscreenElement || documentElement.msFullscreenElement;
  }

  static requestFullscreenOnElement(element): void {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  }

  static exitFullscreen(): void {
    if (documentElement.exitFullscreen) {
      documentElement.exitFullscreen();
    } else if (documentElement.mozCancelFullScreen) {
      documentElement.mozCancelFullScreen();
    } else if (documentElement.webkitExitFullscreen) {
      documentElement.webkitExitFullscreen();
    } else if (documentElement.msExitFullscreen) {
      documentElement.msExitFullscreen();
    }
  }

  static addOnChangeHandler(eventHandler): void {
    documentElement.addEventListener('fullscreenchange', eventHandler);
    documentElement.addEventListener('webkitfullscreenchange', eventHandler);
    documentElement.addEventListener('mozfullscreenchange', eventHandler);
    documentElement.addEventListener('MSFullscreenChange', eventHandler);
  }

  static removeOnChangeHandler(eventHandler): void {
    documentElement.removeEventListener('fullscreenchange', eventHandler);
    documentElement.removeEventListener('webkitfullscreenchange', eventHandler);
    documentElement.removeEventListener('mozfullscreenchange', eventHandler);
    documentElement.removeEventListener('MSFullscreenChange', eventHandler);
  }
}
